import { tokenRef } from 'common/constant';
import Spinner from 'components/ui/Spinner/spinner';
import { useDecodeToken, useLocalStorage } from 'hooks/useStorage';
import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useWidth from '../../../hooks/useWidth';

import useToggle from 'hooks/useToggle';
import UserHeader from '../Header';

const UserSideBar = () => {
  const [isMobileWidth] = useWidth();
  const [sidebarToggle, setsidebarToggle] = useToggle(!isMobileWidth);
  // unused  api commented by binit
  // const { data: userDetails } = useCurrentUserDetailsQuery();
  // const { data: adminData, isLoading: isListingAdministrators } = useListAdministratorQuery();
  const { value: token } = useLocalStorage(tokenRef);
  const isLoading = false;
  useEffect(() => {
    if (isMobileWidth) {
      setsidebarToggle(false);
    } else {
      setsidebarToggle(true);
    }
  }, [isMobileWidth]);

  const handleToggle = () => {
    isMobileWidth && setsidebarToggle();
  };
  const decodedToken = useDecodeToken();
  const isAdmin = decodedToken?.Role === 'Admin' && decodedToken?.UserType == 1 ? true : false;
  // decodedToken?.Role === 'Admin' && decodedToken?.UserType === 1
  if (!token) {
    return <Navigate to="/user" replace={true} />;
  }

  return (
    <div>
      <div className="App">
        <div id="layout-wrapper">
          <UserHeader />

          {isLoading ? (
            <>
              <div className="position-absolute top-50 start-50 translate-middle">
                <Spinner />{' '}
              </div>
            </>
          ) : (
            <Outlet />
          )}
        </div>
      </div>
    </div>
  );
};

export default UserSideBar;
